import InfoIcon from "../../Assets/Icons/outline/info-circle-black.svg";
import ArrowSwapIcon from "../../Assets/Icons/outline/arrow-swap.svg";
import moment from "moment";
import { formatRupiah } from "../../utils/currency";

const PointsLeaderboardTable = ({ data, from, toggleSortPoints }) => {
	return (
		<table className="w-full text-left">
			<thead className="border-t border-b border-black">
				<tr>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">No</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Name</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Email</div>
					</th>
					<th scope="col" className="px-6 py-1 border-e border-black py-1">
						<div className="flex gap-0">
							<div className="">Points</div>
							<img src={ArrowSwapIcon} alt="" className="ml-4 cursor-pointer" onClick={toggleSortPoints} />
						</div>
					</th>

					<th scope="col" className="px-6 py-1">
						<div className="py-1">Reward</div>
					</th>
				</tr>
			</thead>
			<tbody className="font-light">
				{data?.map((item, index) => (
					<tr key={index}>
						<td className="px-6 py-4 w-[100px]">{from++}</td>
						<td className="px-6 py-4">
							<div>{item?.name}</div>
						</td>
						<td className="px-6 py-4">
							<div>{item?.email}</div>
						</td>
						<td className="px-6 py-4">
							<div className="font-semibold">{item?.total_points}</div>
						</td>
						<td className="px-6 py-4">
							<div className="font-semibold">{formatRupiah(item?.reward)}</div>
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
};

export default PointsLeaderboardTable;
